<template>
  <div class="widget-content">
    <vue-apexcharts
      height="500"
      type="line"
      :options="chartOptions"
      :series="chartSeries"
    ></vue-apexcharts>
  </div>
</template>

<script>
import vueApexcharts from "vue3-apexcharts";

export default {
  components: { vueApexcharts },

props: {
  budgetData: {
    type: Array,
    default: () => []
  },
  overallCosts: {
    type: Object,
    default: () => ({})
  }
},

  computed: {
    chartOptions() {
      return {
        chart: {
          stacked: false,
        },
        xaxis: {
          categories: this.getUniqueCategories(),
        },
        dataLabels: {
          enabled: true,
        },
        colors: ['#ed7d31', '#4361ee'],
      };
    },

    chartSeries() {
      return [
        {
          name: "Budżet",
          type: "line",
          data: this.getBudgetSeriesData(),
        },
        {
          name: "Koszty",
          type: "bar",
          data: this.getCostsSeriesData(),
        },
      ];
    },
  },

methods: {
  normalizeCategory(category) {
    if (category === null || category === undefined || category === '') {
      return '(bez kategorii)';
    }

    return String(category).toLowerCase();
  },

  getUniqueCategories() {
    const budgetCategories = (this.budgetData || []).map(item =>
      this.normalizeCategory(item.category)
    );

    const costCategories = Object.values(this.overallCosts || {}).map(item =>
      this.normalizeCategory(item.category)
    );

    return [...new Set([
      ...budgetCategories,
      ...costCategories
    ])];
  },

  getBudgetSeriesData() {
    return this.getUniqueCategories().map(category => {
      const budgetItem = (this.budgetData || []).find(item =>
        this.normalizeCategory(item.category) === category
      );

      return budgetItem ? budgetItem.budget : 0;
    });
  },

  getCostsSeriesData() {
    return this.getUniqueCategories().map(category => {
      const costItem = Object.values(this.overallCosts || {}).find(item =>
        this.normalizeCategory(item.category) === category
      );

      return costItem ? costItem.costs : 0;
    });
  },
},


}
</script>

